module.exports = __webpack_public_path__ + "static/media/verified_icon.22ea4683.svg";